'use client';

import { Fragment } from 'react';
import Button from '@/components/button';
import { Divider } from '@/components/ui/divider';
import { productListResetFilters } from '@/features/products/state/list/actions';
import {
  useProductListDispatch,
  useProductListSelectedFiltersCount
} from '@/features/products/state/list/context';
import { replacePlaceholders } from '@/i18n';
import { listingTranslate } from '@/i18n/translations/listingTranslations';

export const ResetFiltersButton = () => {
  const dispatch = useProductListDispatch();
  const selectedFiltersCount = useProductListSelectedFiltersCount();

  const handleResetFiltersClick = () => {
    dispatch(productListResetFilters({}));
  };

  return (
    <Fragment>
      <div className="py-3 px-2">
        <Button onClick={handleResetFiltersClick} className="w-full py-2">
          <p className="text-xs text-center font-bold text-(--mui-palette-text-secondary)">
            {replacePlaceholders(listingTranslate('filters.reset'), {
              value: selectedFiltersCount
            })}
          </p>
        </Button>
      </div>
      <Divider className="mx-4" />
    </Fragment>
  );
};
